var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "form-fields-contact-to-add flex-column" },
    [
      !_vm.hasContacts && !_vm.disabled
        ? _c(
            "div",
            {
              staticClass:
                "alert alert-info flex-column flex-level ai-center pt-4 pb-3 mb-3 prelative"
            },
            [
              _vm.load
                ? _c(
                    "div",
                    {
                      staticClass:
                        "primary-05-bkg loader-container pabsolute flex-level ai-center jc-center"
                    },
                    [_c("span", { staticClass: "loader" })]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "icon-svg",
                {
                  attrs: {
                    "icon-name": "user",
                    width: 34,
                    height: 34,
                    viewBox: "0 0 34 34"
                  }
                },
                [_c("icon-user", { tag: "component" })],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "gray-60 semi-bold lh-20 mt-2" }, [
                _vm._v(_vm._s(_vm.$l10n.__("Pas de contact lié")))
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.load
        ? _c(
            "div",
            [
              _c("form-fields-contacts-list", {
                attrs: {
                  mode: "manual",
                  lightForm: _vm.lightForm,
                  currentList: _vm.contacts,
                  suggestionMsg: _vm.addToListWording.added,
                  currentStore: _vm.currentStore,
                  options: _vm.options
                },
                on: {
                  "remove-contact": _vm.removeContact,
                  "edit-contact": _vm.editContact
                }
              }),
              _vm._v(" "),
              _c("form-fields-contacts-list", {
                attrs: {
                  mode: "auto",
                  currentList: _vm.suggestionContactsList,
                  actionLabel: _vm.addToListWording.search,
                  currentStore: _vm.currentStore
                },
                on: { "edit-contact": _vm.editContact }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CompassButton", {
        ref: "contactBtn",
        attrs: {
          label: _vm.addToListWording.add,
          type: "secondary",
          disabled: _vm.disabled,
          "data-bot": _vm.getDatabot("btn", _vm.currentStore, "contact")
        },
        on: {
          click: function($event) {
            return _vm.addContact()
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }